import React, {
  ComponentType,
  ForwardRefRenderFunction,
  Suspense,
  useEffect,
  useRef,
  useState,
} from 'react';
import { LOG } from './log';

export type LoaderType = () => Promise<{
  default: React.ComponentType<any>;
}>;

export interface LoadableComponentProps {
  name: string;
  loader: LoaderType;
  loading?: ComponentType<any>;
  lazyLoader?: boolean;
}

const loadComponent = (loader: LoaderType, _loading: ComponentType<any>) => (props: any) => {
  const comRef = useRef<ComponentType<any>>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const _loadComponent = async () => {
      const { default: DefaultComponent } = await loader();

      comRef.current = DefaultComponent;
      setLoading(false);
    };

    _loadComponent();
  }, []);

  if (loading) {
    return _loading;
  }

  const Com = comRef.current!;

  return <Com weId={`${props.weId || ''}_j32a64`} {...props} key={props.pageId} />;
};

function Loadable(opts: LoadableComponentProps): ComponentType<any> {
  const { loader, loading = () => null, lazyLoader = true } = opts;

  let LoadableComponent: ForwardRefRenderFunction<unknown, any>;

  LOG?.set({ logType: 'load-page-view' });

  if (lazyLoader) {
    const Com = React.lazy(loader);

    LoadableComponent = (props) => (
      <Suspense weId={`${props.weId || ''}_ql6g4a`} fallback={loading}>
        <Com weId={`${props.weId || ''}_j2dytt`} {...props} key={props.pageId} />
      </Suspense>
    );
  } else {
    LoadableComponent = loadComponent(loader, loading) as ForwardRefRenderFunction<unknown, any>;
  }

  return LoadableComponent;
}

export default Loadable;
